module.exports = __webpack_public_path__ + "img/Aggregation_Ereignisse.191c2e98.png";